export default class LoanApplication {
    constructor(loan) {
        this.marketingAllowed = true
        this.notPep = true
        this.creditRegistryConsent = true
        this.loan = loan || {
            amount: undefined,
            periodInMonths: undefined,
            productId: 0,
            type: undefined,
            hash: undefined
        }
        this.borrower = {
            firstName: undefined,
            lastName: undefined,
            middleName: undefined,
            pin: undefined,
            birthDate: undefined,
            phone: undefined,
            email: undefined
        }
    }
}
